


"use client";
import React, { useState } from "react";
import styled from "styled-components";
import BasicButton from "@/Common/ButtonsV2/BasicButton";
import { ROUTE_PATH } from "@/utils/Global";
import { Trans } from "react-i18next";
import i18n from "@/i18n";

const HeroContent = styled.div`
  background-color: black;
  display: flex;
  min-width: 900px;
  max-width: 100%;
  padding: 0 20px 150px 20px;
  flex-direction: column;
  overflow: hidden;
  align-items: center;
  font-size: 28px;
  color: white;
  font-weight: 700;
  text-align: center;
  letter-spacing: -0.64px;
  line-height: 42px;
  justify-content: center;
`;

const LogoImage = styled.img`
  aspect-ratio: 2.04;
  object-fit: contain;
  object-position: center;
  width: 80px;
`;

const HeroText = styled.p`
  margin-top: 10px;
  margin-bottom: 15px;
  white-space: pre-wrap;
  span {
    color: #1fbdcb;
  }

  @media (max-width: 991px) {
    max-width: 100%;
  }
`;

export default function VideomonsterHeroContent({ history }) {

  const handleStartButtonClick = () => {
    history.push(ROUTE_PATH.DESIGN_SELECT)
  }

  return (
    <>
      <HeroContent>
        <LogoImage src="https://front.videomonster.com/images-u6yd72dy/web/v2/landing2025/vm-icon.svg" alt="Logo" />
        <HeroText>
          <Trans i18nKey="web.pc.landing.2025.hero.text">
            <span />
          </Trans>
        </HeroText>
        <BasicButton text={i18n.t("common.landing.device.section.btn")} onClick={handleStartButtonClick} color="primary" />
      </HeroContent>
    </>
  );
}
